import {
    IChangePassword,
    IForgotPasswordData,
    ILoginData,
    IRegisterData,
    IResetPasswordData
} from "../../../models/iAuth";
import {appAPI} from "../../../api";

const registerPath = `/auth/register`;
const loginPath = `/auth/login`;
const mePath = `/auth/me`;
const logoutPath = `/auth/logout`;
const changePasswordPath = `/auth/change_password`;
const forgotPasswordPath = `/auth/forgot-password`;
const resetPasswordPath = `/auth/reset-password`;

export const authAPI = {
    login: async (authData: ILoginData) => {
        const res = await appAPI.post(loginPath, authData);
        return res.data;
    },
    register: async (registerData: IRegisterData) => {
        const res = await appAPI.post(registerPath, registerData);
        return res.data;
    },
    me: async () => {
        const res = await appAPI.get(mePath);
        return res.data;
    },
    out: async () => {
        return await appAPI.post(logoutPath);
    },
    changePassword: async (changeData: IChangePassword) => {
        const res = await appAPI.post(changePasswordPath, changeData);
        return res.data;
    },
    forgotPassword: async (data: IForgotPasswordData) => {
        const res = await appAPI.post(forgotPasswordPath, data);
        return res.data;
    },
    resetPassword: async (data: IResetPasswordData) => {
        const res = await appAPI.post(resetPasswordPath, data);
        return res.data;
    },
};